"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userDisplayName = userDisplayName;
exports.userDisplayInitials = userDisplayInitials;
/**
 * Creates a user identifier string of either their name if available, or their email address
 * @param user A user object
 * @returns A string of either the users name, or their email address
 */
function userDisplayName(user) {
    if (user.firstname || user.lastname) {
        return "".concat(user.firstname, " ").concat(user.lastname).trim();
    }
    return user.username;
}
/**
 * Creates a user initials string based on either their first & last names, or their email address
 * @param user A user object
 * @returns A string containing the initials of the users name, or email address
 */
function userDisplayInitials(user) {
    var initials = '';
    if (user.firstname) {
        initials = user.firstname[0].toUpperCase();
    }
    if (user.lastname) {
        initials += user.lastname[0].toUpperCase();
    }
    if (user.username && !initials) {
        initials = user.username[0];
    }
    if (!initials) {
        initials = '??';
    }
    return initials;
}
//# sourceMappingURL=userDisplayName.js.map